export const DRAWER_WIDTH = 240;
export const APP_LOGO =
  "/app_logo.png";
export const APP_BANNER =
  "/myapp.png";
export const LOCAL = "local";
export const ADMIN = "admin";
export const USER = "user";
export const PRODUCTION = "production";
export const TRANSPARENCY = 0.8;
export const state = PRODUCTION;
export const API_ENDPOINT =
  state === PRODUCTION ? "https://api.hoineki.com/" : "http://localhost:5000/";

export const TimeZoneIndia = {
  timeZone: "Asia/Kolkata", // IST Timezone
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};
export const TimeOnlyZone = {
  timeZone: "Asia/Kolkata",
  hour: "2-digit",
  minute: "2-digit",
};
